import { render, staticRenderFns } from "./AutoBatchRenewal.vue?vue&type=template&id=3f15073e&"
import script from "./AutoBatchRenewal.vue?vue&type=script&lang=js&"
export * from "./AutoBatchRenewal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports